<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_309_7617)">
      <path
        d="M3.84521 16.598C3.2028 16.598 2.73572 16.0701 2.73572 15.422V10.386C2.73572 10.2222 2.60289 10.0898 2.43939 10.0898C2.2756 10.0898 2.14307 10.2222 2.14307 10.386V15.422C2.14307 16.3972 2.87605 17.1906 3.84519 17.1906C4.00869 17.1906 4.14152 17.0581 4.14152 16.8943C4.14154 16.7306 4.00871 16.598 3.84521 16.598Z"
        fill="currentColor"
      />
      <path
        d="M5.29138 16.6089H4.99506C4.83156 16.6089 4.69873 16.7414 4.69873 16.9052C4.69873 17.069 4.83156 17.2015 4.99506 17.2015H5.29138C5.45518 17.2015 5.58771 17.069 5.58771 16.9052C5.58771 16.7414 5.45518 16.6089 5.29138 16.6089Z"
        fill="currentColor"
      />
      <path
        d="M17.8686 9.49715H16.663V6.78768C16.663 5.86096 15.9563 5.07706 15.0709 4.83392C15.0893 4.73259 15.0816 4.62519 15.043 4.5217L13.7643 1.09126C13.7093 0.943946 13.5982 0.824447 13.4552 0.759182C13.312 0.693918 13.1491 0.687847 13.0018 0.743105L2.73922 4.57407C2.63637 4.61245 2.55062 4.6764 2.48622 4.75594H2.01145C0.878806 4.75594 0.0688477 5.66748 0.0688477 6.78768V17.1999C0.0688477 18.3447 0.878829 19.2759 2.01145 19.2759H14.4979C15.6305 19.2759 16.663 18.3447 16.663 17.1999V14.831H17.8686C19.0029 14.831 19.9226 13.9114 19.9226 12.777V11.5512C19.9226 10.4166 19.0029 9.49715 17.8686 9.49715ZM12.8609 2.06081L13.8654 4.75594H5.64091L12.8609 2.06081ZM15.4777 17.1999C15.4777 17.6826 14.9687 18.0906 14.4979 18.0906H2.01145C1.54061 18.0906 1.25413 17.6826 1.25413 17.1999V6.78768C1.25413 6.3131 1.52442 5.94125 2.01145 5.94125H14.4979C14.9849 5.94125 15.4777 6.3131 15.4777 6.78768V9.49715H13.6795C12.5451 9.49715 11.6255 10.4167 11.6255 11.5512V12.777C11.6255 13.9114 12.5451 14.831 13.6795 14.831H15.4777V17.1999ZM18.7373 12.777C18.7373 13.2568 18.3483 13.6457 17.8686 13.6457H13.6795C13.1997 13.6457 12.8108 13.2568 12.8108 12.777V11.5512C12.8108 11.0714 13.1997 10.6823 13.6795 10.6823H17.8686C18.3484 10.6823 18.7373 11.0714 18.7373 11.5512V12.777Z"
        fill="currentColor"
      />
      <path
        d="M14.3049 11.5737C13.9912 11.5737 13.7368 11.8284 13.7368 12.1421C13.7368 12.4558 13.9912 12.7099 14.3049 12.7099C14.6182 12.7099 14.8729 12.4558 14.8729 12.1421C14.8729 11.8284 14.6182 11.5737 14.3049 11.5737Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_309_7617">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Pay',
} as DefineComponent
</script>
